import React, { useState } from 'react';
import { Phone, MapPin, Clock, Mail, ArrowRight } from 'lucide-react';
import { businessInfo, services } from '../mockData';
import { toast } from 'sonner';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    vehicle: '',
    service: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success("Message Sent!", {
      description: "Thank you for contacting us. We'll get back to you shortly.",
      duration: 4000,
    });
    setFormData({
      name: '',
      phone: '',
      email: '',
      vehicle: '',
      service: '',
      message: ''
    });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="contact-page">
      <section className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-hero-title">Contact Us</h1>
          <p className="page-hero-subtitle">
            Get in touch for a free quote on mobile car audio installation
          </p>
        </div>
      </section>

      <section className="contact-main-section">
        <div className="contact-main-content">
          <div className="contact-info-box">
            <h2 className="contact-box-title">Get In Touch</h2>
            <p className="contact-box-description">
              Ready to upgrade your car audio system? Contact us today for a free
              consultation and quote. We offer professional mobile installation
              services throughout Metro Atlanta.
            </p>

            <div className="contact-info-items">
              <div className="contact-info-item">
                <div className="contact-info-icon">
                  <Phone size={24} />
                </div>
                <div className="contact-info-text">
                  <h4>Phone</h4>
                  <a href={`tel:${businessInfo.phone}`}>{businessInfo.phone}</a>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-icon">
                  <MapPin size={24} />
                </div>
                <div className="contact-info-text">
                  <h4>Location</h4>
                  <p>{businessInfo.location}</p>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-icon">
                  <Clock size={24} />
                </div>
                <div className="contact-info-text">
                  <h4>Hours</h4>
                  <p>{businessInfo.hours}</p>
                </div>
              </div>
            </div>

            <div className="contact-cta-box">
              <h3>Prefer to call?</h3>
              <a href={`tel:${businessInfo.phone}`} className="btn-primary btn-full">
                <Phone size={20} />
                Call Now
              </a>
            </div>
          </div>

          <div className="contact-form-box">
            <form onSubmit={handleSubmit} className="contact-page-form">
              <h3 className="form-box-title">Send Us a Message</h3>
              <input
                type="text"
                name="name"
                placeholder="Your Name *"
                value={formData.name}
                onChange={handleChange}
                className="form-input"
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number *"
                value={formData.phone}
                onChange={handleChange}
                className="form-input"
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                className="form-input"
              />
              <input
                type="text"
                name="vehicle"
                placeholder="Vehicle (Year, Make, Model) *"
                value={formData.vehicle}
                onChange={handleChange}
                className="form-input"
                required
              />
              <select
                name="service"
                value={formData.service}
                onChange={handleChange}
                className="form-input"
                required
              >
                <option value="">Select Service *</option>
                {services.map((service) => (
                  <option key={service.id} value={service.title}>
                    {service.title}
                  </option>
                ))}
              </select>
              <textarea
                name="message"
                placeholder="Additional Details or Questions"
                value={formData.message}
                onChange={handleChange}
                className="form-textarea"
                rows="4"
              />
              <button type="submit" className="btn-primary btn-full">
                Send Message
                <ArrowRight size={20} />
              </button>
            </form>
          </div>
        </div>

        {/* Google Map showing service area */}
        <div className="contact-map-section">
          <h3 className="map-title">Our Service Area</h3>
          <div className="contact-map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d106136.56287393267!2d-84.41971803780934!3d33.616819282746295!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f4fc268dd1e0ad%3A0x15c7b8e5b5a53e85!2sForest%20Park%2C%20GA!5e0!3m2!1sen!2sus!4v1705087425836!5m2!1sen!2sus"
              width="100%"
              height="500"
              style={{ border: '2px solid var(--border-subtle)' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Forest Park, GA - Service Location"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;